// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import "@babel/polyfill";
import '../static/css/common.css';

axios.defaults.withCredentials=true;
Vue.prototype.$http = axios;

import qs from 'qs' // 这个是用于把json转成&符号拼接的参数传递
Vue.prototype.$qs = qs;
import './icons'

import Cookie from 'js-cookie'
Vue.prototype.$cookie = Cookie;

Vue.prototype.$host = process.env.API_ROOT;

import * as common from './JavaScript/common.js'
Vue.prototype.$common = common;

Vue.use(ElementUI);

Vue.config.productionTip = false

// router.beforeEach((to, from, next) => {
//   // var userInfo= JSON.parse(Cookies.get('user'));//获取浏览器缓存的用户信息
//   // 默认不做登陆校验
//   return;
//   if(Cookie.get('user') && JSON.parse(Cookie.get('user'))){//如果有就直接到首页咯
//     next();
//   }else{
//     if(to.path === '/login'){//如果是登录页面路径，就直接next()
//       next();
//     }else{//不然就跳转到登录；
//       next('/login');
//     }
//   }
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js